import { t } from 'i18next';
import { useModal } from 'components/modal/ModalStack';
import { classNames } from 'libs/react';
import { useEffect } from 'libs/react';
import { useState } from 'libs/react';
import { remove } from 'libs/util/array';
import { MediaPickerItem } from './MediaPickerItem';
import { Button } from 'components/Button';
import { MediaLibrary } from 'components/media/MediaLibrary';
import { React } from 'libs/react';
import './MediaCustomPicker.scss';
/**
 * @component MediaCustomPicker
 * @since 1.0.0
 */
export function MediaCustomPicker(props) {
    const { size, style, title, editable, types, multiple, useLink, primaryImageId, hasVisibilitySelection, visibilityValues, hasLanguageSelection, languageValues, languageOptions } = Object.assign({ size: 'medium', style: 'normal', types: 'image/*, application/pdf', multiple: false }, props);
    const modal = useModal();
    const [medias, setMedias] = useState(props.medias || []);
    /**
     * @function onBrowse
     * @since 1.0.0
     * @hidden
     */
    function onBrowse() {
        modal.present({
            title: t('Select Media'),
            picto: 'images',
            className: 'media-picker-modal',
            modal: (React.createElement(MediaLibrary, { types: types, onSelect: onSelect, multiple: multiple, medias: medias }))
        });
    }
    /**
     * @function onItemClick
     * @since 1.0.0
     * @hidden
     */
    function onItemClick(media) {
        if (props.onItemClick) {
            props.onItemClick(media);
        }
    }
    /**
     * @function onSelect
     * @since 1.0.0
     * @hidden
     */
    function onSelect(medias) {
        setMedias(medias);
        if (props.onPick) {
            props.onPick(multiple ? medias : medias[0]);
        }
        modal.dismiss();
    }
    /**
     * @function onRemove
     * @since 1.0.0
     * @hidden
     */
    function onRemove(media) {
        const mediasCopy = [...medias];
        remove(mediasCopy, media);
        setMedias(mediasCopy);
        if (props.onPick) {
            props.onPick(mediasCopy);
        }
    }
    /**
     * @function onReorder
     * @since 1.0.0
     * @hidden
     */
    function onReorder(from, to) {
        if (from === to) {
            return;
        }
        const mediasCopy = [...medias];
        const [moved] = mediasCopy.splice(from, 1);
        mediasCopy.splice(to, 0, moved);
        setMedias(mediasCopy);
        if (props.onPick) {
            props.onPick(mediasCopy);
        }
    }
    useEffect(() => {
        setMedias(props.medias || []);
    }, [props.medias]);
    const className = classNames('media-custom-picker', 'media-custom-picker--' + size, 'media-custom-picker--' + style, { 'media-custom-picker--has-media': medias.length > 0 }, { 'media-custom-picker--multiple': multiple }, props.className);
    return (React.createElement("div", { className: className },
        !useLink ? (React.createElement("div", { className: "media-custom-picker-foot" },
            React.createElement(Button, { className: "media-custom-picker-select-button", style: "primary", label: t('Select'), onPress: onBrowse }))) : (medias.length === 0 && (React.createElement("div", { className: "media-custom-picker-image-text", onClick: onBrowse }, title !== null && title !== void 0 ? title : t('Select Image')))),
        React.createElement("div", { className: "media-custom-picker-body" }, medias.map((media, index) => (React.createElement(MediaPickerItem, { key: media.id, index: index, editable: editable, media: media, onItemClick: onItemClick, onRemove: onRemove, onReorder: multiple ? onReorder : undefined, types: types, primary: primaryImageId === media.id, hasVisibilitySelection: hasVisibilitySelection, visibilityValues: visibilityValues, hasLanguageSelection: hasLanguageSelection, languageValues: languageValues, languageOptions: languageOptions }))))));
}
